import { render, staticRenderFns } from "./ServersidePagingSelector.vue?vue&type=template&id=0a44d116&scoped=true"
import script from "./ServersidePagingSelector.vue?vue&type=script&lang=ts"
export * from "./ServersidePagingSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44d116",
  null
  
)

export default component.exports